import { AccordionSummary, Grid, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import useStyles from '../style';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import Loading from '../../../../components/Loading';
import { FilterStatusHeader } from './FilterStatusHeader';
import { canShowEdit } from '../../../../utils/functions';

export function Exceptions({ providerId, isEditing }) {
  const classes = useStyles();

  const [exceptions, setExceptions] = useState([]);
  const [status, setStatus] = useState('ativo');
  const [isLoading, setLoading] = useState(false);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: <span></span>,
          },
        }}
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(3498, 'Alterar') && canShowEdit()) {
            window.location.href = window.location.origin + `/app/fornecedor/${providerId}/excecao/${rowData.fornecedorClassificacaoExcecaoId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Rede',
            field: 'ancora',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Classificação',
            field: 'classificacao',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(3498, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/fornecedor/${providerId}/excecao/${rowData.fornecedorClassificacaoExcecaoId}`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(3498, 'Alterar') && canShowEdit() && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/fornecedor/${providerId}/excecao/${rowData.fornecedorClassificacaoExcecaoId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={exceptions}
      />
    ),
    [exceptions],
  );

  const fetchProviderExceptions = async () => {
    setLoading(true);
    const res = await api.get(
      `/FornecedoresClassificacoesExcecoes/ConsultarGridCadastro?fornecedorId=${providerId}&${
        status ? `status=${status}` : ''
      }`,
    );
    res.data.resposta?.[0]?.key === 'Notificacao' || res.data.resposta?.[0]?.key === ''
      ? setExceptions([])
      : setExceptions(res.data.resposta);
    setLoading(false);
  };

  useEffect(() => {
    if (providerId) {
      fetchProviderExceptions();
    }
  }, [providerId]);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
        <Typography className={classes.heading}>Classificações Exceções</Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>
        <Grid container>
          <Grid item xs={12} className={classes.registerBtn}>
            <FilterStatusHeader
              fetchFunc={fetchProviderExceptions}
              status={status}
              setStatus={setStatus}
            />
            {isEditing && !!findPermission(3498, 'Cadastrar') && (
              <Link
                className={classes.button}
                to={`/app/fornecedor/${providerId}/cadastrar-excecao`}
              >
                Novo Item
              </Link>
            )}
          </Grid>

          {isLoading ? (
            <Loading />
          ) : (
            <Grid item xs={12}>
              {memoizedTable}
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
